import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';

/**
 * Fired when the user clicks the "Forgot password?" / "Can't sign in?" link
 * on the Login page.
 *
 * @param {object} props
 * @param {string} props.pageName           - Current page pathname (window.location.pathname)
 * @param {'email'|'social'|'both'} props.loginMethod  - Login methods available on the page
 * @param {boolean} props.emailPrefilled    - Whether the email field already had a value
 */
export var trackForgotPasswordClicked = function trackForgotPasswordClicked() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$pageName = _ref.pageName,
    pageName = _ref$pageName === void 0 ? window.location.pathname : _ref$pageName,
    _ref$loginMethod = _ref.loginMethod,
    loginMethod = _ref$loginMethod === void 0 ? 'email' : _ref$loginMethod,
    _ref$emailPrefilled = _ref.emailPrefilled,
    emailPrefilled = _ref$emailPrefilled === void 0 ? false : _ref$emailPrefilled;
  trackRubriqEvent('Forgot Password Clicked', {
    page_name: pageName,
    login_method: loginMethod,
    email_prefilled: emailPrefilled
  });
};

/**
 * Fired when the user submits their email on the Password Reset request page.
 *
 * @param {object} props
 * @param {string} props.email                                  - Email entered by the user
 * @param {'success'|'rate_limited'|'error'} props.requestStatus - Outcome of the API call
 * @param {'yes'|'no'|'unknown'} props.existingAccount          - Whether the account exists
 */
export var trackPasswordResetRequested = function trackPasswordResetRequested() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    email = _ref2.email,
    requestStatus = _ref2.requestStatus,
    _ref2$existingAccount = _ref2.existingAccount,
    existingAccount = _ref2$existingAccount === void 0 ? 'unknown' : _ref2$existingAccount;
  trackRubriqEvent('Password Reset Requested', {
    email: email,
    request_status: requestStatus,
    existing_account: existingAccount
  });
};